import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ICollection } from '../collection-schema';
import { collectionSchema } from '../collection-schema';

export const searchCollectionsResponseSchema = createApiResponseSchema(
  z.array(collectionSchema),
) as z.ZodSchema<IAPI<ICollection[]>>;

export type ISearchCollectionsResponse = IAPI<ICollection[]>;
